import styled from "styled-components";

export const RequirementContentWrap = styled.div`
  margin: 20px 0;
  margin-bottom: 40px;
`